import { render, staticRenderFns } from "./AffiliateRevenue.vue?vue&type=template&id=50388cdb"
import script from "./AffiliateRevenue.vue?vue&type=script&lang=js"
export * from "./AffiliateRevenue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports